import React from "react";
import { Button, Modal } from "@picklebet/ui";

import * as styles from "./LeaveSignUpModal.module.scss";

type LeaveSignUpModalProps = {
  isOpen: boolean;
  onContinue: () => void;
  onLeave: () => void;
};

const LeaveSignUpModal = ({
  isOpen,
  onContinue,
  onLeave,
}: LeaveSignUpModalProps) => (
  <Modal.Root
    open={isOpen}
    onOpenChange={(open) => {
      if (!open) onContinue();
    }}
  >
    <Modal.Body>
      <Modal.Header>
        <Modal.Heading>
          <Modal.Title>Wait! You're almost there.</Modal.Title>
          <Modal.Subtitle>Signing up takes just 2 minutes.</Modal.Subtitle>
        </Modal.Heading>
      </Modal.Header>

      <Modal.Footer>
        <div className={styles.actions}>
          <Button
            className={styles.leaveButton}
            variant="secondary"
            size="md"
            onClick={onLeave}
          >
            Leave
          </Button>
          <Button
            className={styles.continueButton}
            variant="primary"
            size="md"
            onClick={onContinue}
          >
            Continue Sign Up
          </Button>
        </div>
      </Modal.Footer>
    </Modal.Body>
  </Modal.Root>
);

export { LeaveSignUpModal };
